export default "__VITE_ASSET__DuiwMmIZ__"